'use strict';

import template from './header.html';

const controller = function ($rootScope, userModel) {
  'ngInject';

  this.showActivation = false;

  // this.showPolicyChange = false;

  $rootScope.$on('userModel:initialized', () => {
    this.showActivation = userModel.item.id && !userModel.item.isActiveGuide;
    // this.showPolicyChange = userModel.item.id && userModel.item.isTermsUpdated;
  });

  this.done = () => {
    this.showActivation = false;
  };

  // this.doneTerms = () => {
  //   this.showPolicyChange = false;
  // };
};

const saHeader = function () {
  return {
    template: template,
    replace: true,
    controllerAs: 'ctrl',
    controller: controller
  };
};

export default saHeader;



// WEBPACK FOOTER //
// ./app/src/directives/header.component.js